<template>
  <NuxtLayout>
    <VideoHeader v-if="page.video_url" :title-visible="false" stacked-elements class="placeList__VideoHeader">
      <h1 v-text="page.title" />
    </VideoHeader>
    <HeroHeader v-else class="placeList__HeroHeader" :image="page.image" :title-visible="false" stacked-elements>
      <h1 v-text="page.title" />
    </HeroHeader>
    
    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_placeList.scss');
  @import url('@/assets/styles/pages/_placeDetail.scss');
</style>